import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import { BaseLeadPage, CarleadHIWWhyChooseWkdaFaq, CarleadStep1CustomerPopup, } from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadStep1CustomerPopup}
      content={CarleadHIWWhyChooseWkdaFaq}
      headlineDesktop='carleadCreation.form.step1.headline'
      headlineMobile='carleadCreation.form.step1.headline.mobile'
      showCounterHeadline={true}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
